import * as React from 'react'
import { Field } from 'formik'
import { Select } from '@workwave-tidal/core/components'

import type { Option } from '../formConfig'

type TechRegionSelectProps = {
  techRegionOptions: Option[]
}

export function TechRegionSelect(props: TechRegionSelectProps) {
  const { techRegionOptions } = props

  const sortedOptions = techRegionOptions?.sort((a: Option, b: Option) => {
    const labelA = a?.label?.toLowerCase()
    const labelb = b?.label?.toLowerCase()
    if (labelA < labelb) {
      return -1
    }
    if (labelA > labelb) {
      return 1
    }
    return 0
  })

  return (
    <Field name="techRegionId" size="medium" label="Tech Region">
      {({ field, form }) => (
        <Select<Option>
          testId="filters-techRegionSelect"
          key={'techRegionId'}
          items={sortedOptions}
          getLabel={(option) => option.label}
          label="Tech Region"
          optionMode="normal"
          size="medium"
          getId={(o) => o?.id}
          value={
            techRegionOptions?.find((row) => row?.id == field?.value) ?? null
          }
          onChange={(e) => form?.setFieldValue('techRegionId', e?.id)}
          placeholder="Search Tech Regions"
        />
      )}
    </Field>
  )
}
